export const roundUpTo5 = num => {
  if (!num) {
    return 5;
  }
  return Math.ceil(num / 5) * 5;
};
